/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Copy_ButtonInputs */



/**
* | output |
* | --- |
* | "Copy Code" |
*
* @param {Offline_Activation_Copy_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_copy_button = /** @type {((inputs?: Offline_Activation_Copy_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Copy_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le code")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia il codice")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar código")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制代码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コードをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोड कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar código")
	return /** @type {LocalizedString} */ ("Copy Code")
});